import React from "react";
import { Trash } from "@phosphor-icons/react";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import {
  FieldDefinitionOption,
  MeterFieldMapping,
  SPECIAL_SOURCE_OPTIONS,
  decodeSource,
  encodeSource,
} from "./types";

interface MeterFieldMappingRowProps {
  mapping: MeterFieldMapping;
  fieldDefinitions: FieldDefinitionOption[];
  onChange: (mapping: MeterFieldMapping) => void;
  onRemove: () => void;
}

/**
 * One field mapping: which document field is filled from which source on the
 * meter asset (voorziening).
 */
export const MeterFieldMappingRow: React.FC<MeterFieldMappingRowProps> = ({
  mapping,
  fieldDefinitions,
  onChange,
  onRemove,
}) => {
  return (
    <div className="flex items-center gap-2">
      <Input
        aria-label="Documentveld"
        value={mapping.documentField}
        placeholder="documentveld (bijv. ean)"
        onChange={(e) => onChange({ ...mapping, documentField: e.target.value })}
        className="max-w-[200px]"
      />

      <span className="text-muted-foreground text-sm">&larr;</span>

      <Select
        value={encodeSource(mapping.source)}
        onValueChange={(value) => onChange({ ...mapping, source: decodeSource(value) })}
      >
        <SelectTrigger className="max-w-[320px]" aria-label="Bron">
          <SelectValue placeholder="Kies een bron" />
        </SelectTrigger>
        <SelectContent position="popper" sideOffset={4} align="start" className="max-h-[260px]">
          {fieldDefinitions.map((fd) => (
            <SelectItem key={`fieldValue:${fd.fieldName}`} value={`fieldValue:${fd.fieldName}`}>
              {fd.displayName}
            </SelectItem>
          ))}
          {SPECIAL_SOURCE_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label="Verwijder veldkoppeling"
        onClick={onRemove}
      >
        <Trash className="h-4 w-4 text-destructive" />
      </Button>
    </div>
  );
};

export default MeterFieldMappingRow;
